import * as BASE from './base';

export function Register(email, name) {
    return BASE.POST('api/register', { email, name });
}

export function ConfirmUser(email, firstName, lastName, className, studentId, pin) {
  var data = { email, firstName, lastName, className, studentId, pin };
  return BASE.POST('api/confirmuser', data);
}

export function GetUserDetails() {
    return BASE.POST('api/userdetails', { });
}

export function GetSessionData(sessionCode) {
    return BASE.POST('api/sessiondata', { sessionCode });
}

export function SubmitAnswers({ sessionCode, answers }) {
    return BASE.POST('api/submitanswers', { sessionCode, answers });
}